module.exports = __webpack_public_path__ + "static/media/dash.2a84f054.jpg";